import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShowException } from 'store/Application/appActions'
import { projectAPIBuilder } from './BoMAsyncActions'

export const recalculateProjectWithUpdatedPrices = createAsyncThunk<
  any,
  any,
  { state: any }
>('project/recalculateProjectWithUpdatedPrices', async (_args, thunkAPI) => {
  const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

  try {
    return await api.RecalculateWithUpdatedPrices(projectId)
  } catch (ex) {
    ShowException('project', ex)
    throw ex
  }
})
